import { accountLabels } from "./account-labels";
const store = {
  namespaced: true,
  state: {
    participantId: null,
    accounts: [],
    ready: false,
  },
  actions: {
    async load({state, commit}, data) {

      if(!data || !data.participantId) return;

      if (state.accounts.length === 0 || state.participantId !== data.participantId || data.force) {
        commit("setAccountsReady", false);
        commit("setParticipantId", data.participantId);
        try {
          let result = await romeApi.get(`/participant/${data.participantId}/account`, {forEnrollment: true});

          await extendDCAAccounts(data.participantId, result);

          commit("setAccounts", result);
        }
        catch (e) {
          state.accounts = [];
        }

      } else {
        commit("setAccountsReady", true);
      }
    },

    async updateStatus({commit}, data) {
      await romeApi.post(`/participant/${data.participantId}/account/${data.accountId}/status`, { newStatus: data.newStatus });
      commit("updateAccount", { accountId: data.accountId, accountStatus: data.newStatus });
    },

    async activate({commit}, data) {
      await romeApi.post(`/participant/${data.participantId}/account/${data.accountId}/activate`);
      commit("updateAccount", { accountId: data.accountId, accountStatus: accountLabels.status.active });
    },

    async updateCipStatus({commit}, data){
      if(data.cipNote) { // manually override of status
        await romeApi.post(`/participant/${data.participantId}/account/${data.accountId}/cip`, { cipStatus: data.newCipStatus, cipNote: data.cipNote });
      }
      commit("updateAccount", { accountId: data.accountId, cipStatus: data.newCipStatus, cipApprovalDate: Date.now() });

    },

    async terminate({commit}, data) {
      var res = await romeApi.post(`/participant/${data.participantId}/account/${data.accountId}/terminate`, data);
      commit("updateAccount", data);
      return res;
    },

    async closeHsaAccount({commit}, data) {
      var res = await romeApi.post(`/participant/${data.participantId}/account/${data.accountId}/close`, data);
      commit("updateAccount", data);
      return res;
    },

  },
  mutations: {
    setParticipantId(state, value) {
      state.participantId = value;
    },
    setAccountsReady(state, value) {
      state.ready = value;
    },
    setAccounts(state, accounts) {
      state.accounts = extendAccounts(accounts);
      state.ready = true;
    },
    updateAccount(state, data) {
      var acc = _.find(state.accounts, { accountId: data.accountId });
      utils.copyCommonProperties(data, acc);

      if (!!data.cipApprovalDate) {
        if (moment(data.cipApprovalDate).isAfter(moment(acc.effectiveDate))) {
          acc.effectiveDate = data.cipApprovalDate;
        }
      }
    },
  }
};

function extendAccounts(accounts) {
  accounts = _.orderBy(accounts, ['planStartDate', 'vanityAccountType'], ['desc', 'asc']);
  return accounts.map((a) => {
    a = _.clone(a);
    let prefix = a.vanityAccountType ? a.vanityAccountType : a.planType;
    a.displayName = a.plan.planDisplayName
    return a;
  })
}

async function extendDCAAccounts(participantId, accounts) {
  let result = _.clone(accounts);

  if (_.find(result, (a) => { return a.planType === "DCA"})) {
    let pendingClaims = await romeApi.get(`/participant/${participantId}/memberclaim/pending`);
    result.forEach((a) => {
      if (a.planType === "DCA") {
        let onHoldClaim = _.find(pendingClaims, (c) => {
          return a.accountId === c.accountId && c.onHoldAmountRemaining > 0;
        });
        if (onHoldClaim) {
          a.onHoldAmountRemaining = onHoldClaim.onHoldAmountRemaining;
          a.memberClaimId = onHoldClaim.memberClaimId;
        }
      }
    });
  }

  return result;
}
export default store;



// WEBPACK FOOTER //
// ./src/accounts/x-accounts.js